import { Stack, Typography } from '@mui/material';
import useCountriesData from 'views/Components/Shared/Queries/countriesQuery';

export default function CountryCell({ params }) {
	const { data } = useCountriesData();
	const pais = data;
	const filteredCountry = pais?.find((country) => country.id === params.value);
	return (
		<Stack
			direction="row"
			alignItems="center"
			alignContent="center"
			justifyContent="center"
			height={'100%'}
		>
			<Typography
				style={{
					textTransform: 'capitalize',
					fontSize: '14px',
				}}
			>
				{filteredCountry?.name || params.value}
			</Typography>
		</Stack>
	);
}
